// utils/colorMapper.js
export const colors = [
  "#57E2FF",
  "#33FF57",
  "#FF33B3",
  "#FFAB33",
  "#FFB3FF",
  "#FF6F61",
  "#FFDEB3",
  "#FFC300",
  "#FFC0CB",
  "#FF63A3",
  "#FFB3B3",
  "#B3FFB3",
  "#B3FFFF",
  "#FF5733",
  "#33A1FF",
  "#A133FF",
  "#33FFAB",
  "#FF3383",
  "#A3FFB3",
  "#FFB333",
  "#B3A1FF",
  "#FF33A1",
  "#FFA133",
  "#FFD1DC",
  "#FFD9B3",
  "#FFB3D9",
  "#33FFF7",
  "#FFC300",
  "#DAF7A6",
  "#FF5733",
  "#C70039",
  "#900C3F",
  "#581845",
  "#FFC300",
  "#DAF7A6",
  "#FF914D",
  "#FF6F61",
  "#6B5B95",
  "#FF6F61",
  "#F7CAC9",
  "#92A8D1",
  "#955251",
  "#B5E61D",
  "#6B5B95",
  "#20B2AA",
  "#87CEFA",
  "#778899",
  "#FF6347",
  "#FA8072",
  "#E9967A",
  "#F08080",
  "#FF4500",
  "#FF1493",
  "#FF69B4",
  "#BA55D3",
  "#9370DB",
  "#8A2BE2",
  "#7B68EE",
  "#6A5ACD",
  "#483D8B",
  "#5F9EA0",
  "#4682B4",
  "#4169E1",
  "#0000FF",
  "#00008B",
  "#1E90FF",
  "#00BFFF",
  "#87CEEB",
  "#00CED1",
  "#20B2AA",
  "#008B8B",
  "#008080",
  "#00FA9A",
  "#32CD32",
  "#98FB98",
  "#8FBC8F",
  "#3CB371",
  "#2E8B57",
  "#228B22",
  "#66CDAA",
  "#20B2AA",
  "#7FFF00",
  "#ADFF2F",
  "#7CFC00",
  "#32CD32",
  "#00FF7F",
  "#00FA9A",
  "#008000",
  "#006400",
  "#228B22",
  "#ADFF2F",
  "#7FFF00",
  "#FFFFE0",
  "#FFEFD5",
  "#FFE4B5",
  "#FFDAB9",
  "#FFE4C4",
  "#FFDEAD",
  "#FFEBCD",
  "#FFF8DC",
  "#FFF5EE",
  "#F5FFFA",
  "#F0FFF0",
  "#F0FFFF",
  "#F0F8FF",
  "#F5F5DC",
  "#FAFAD2",
  "#FFFF00",
  "#FFD700",
  "#FFA500",
  "#FF8C00",
  "#FF7F50",
  "#FF6347",
  "#FF4500",
]

const colorMap = {}

export const getColorForValue = (value) => {
  if (!colorMap[value]) {
    colorMap[value] = colors[Math.floor(Math.random() * colors.length)]
  }
  return colorMap[value]
}
